import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { downloadFile } from '@cp/shared/lib/browser';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { RotateIcon } from '@cp/ds/src/icons/rotate';
import { DeleteIcon } from '@cp/ds/src/icons/delete';
import { ActionBarProps } from './model';

export const ActionBar: React.FC<ActionBarProps> = ({ imageUrl, orientation = 'vertical', sx, onDelete, onRotate, showDownloadButton }) => {
  return (
    <Stack direction={orientation === 'horizontal' ? 'row' : 'column'} spacing={2} sx={sx}>
      <Button color="gray" onClick={onRotate} size="small" square variant="secondary">
        <RotateIcon />
      </Button>
      <Button color="gray" onClick={onDelete} size="small" square variant="secondary">
        <DeleteIcon />
      </Button>
      {showDownloadButton && imageUrl ? (
        <Button
          color="gray"
          onClick={() => {
            if (!imageUrl) {
              return;
            }

            let filename: string;
            if (imageUrl.startsWith('data:')) {
              const mimeMatch = imageUrl.match(/data\/([^;]+)/);
              const mimeType = mimeMatch ? mimeMatch[1] : 'png';
              const timestamp = Date.now();
              filename = `ai-image-${timestamp}.${mimeType}`;
            } else {
              filename = imageUrl.split('/').pop() ?? 'image';
            }

            downloadFile({ resource: imageUrl, filename });
          }}
          size="small"
          square
          variant="secondary"
        >
          <DownloadIcon />
        </Button>
      ) : null}
    </Stack>
  );
};
